import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(SectionWrapper)``

export const Wrapper = styled(Container)``

export const ContentContainer = styled.div`
  padding-top: ${({ theme }) => theme.typography.pxToRem(50)};
  padding-bottom: ${({ theme }) => theme.typography.pxToRem(48)};
  padding-left: ${({ theme }) => theme.typography.pxToRem(60)};
  padding-right: ${({ theme }) => theme.typography.pxToRem(60)};

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  min-height: 710px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 2rem 1rem;
    min-height: 900px;
  }
`

export const BgImage = styled(CustomBgImage)`
  min-height: 710px;
  border-radius: 20px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    min-height: 900px;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  font-style: normal;
  font-weight: 700;
  line-height: ${({ theme }) => theme.typography.pxToRem(30)};
  opacity: 0.9;
`

export const SliderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .swiper {
    max-width: 762px;
    margin-left: 0;
    margin-bottom: 0;

    ${({ theme }) => theme.breakpoints.down("md")} {
      max-width: 100%;
    }
  }

  .swiper-slide {
    height: 500px;
    align-items: end;
    display: flex;
    ${({ theme }) => theme.breakpoints.down("md")} {
      height: 700px;
    }
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
`

export const InfoContainer = styled.div`
  max-width: 762px;
`

export const Logo = styled(CustomImage)`
  max-width: 300px;
  max-height: 70px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(32)};

  img {
    max-width: 300px;
    max-height: 70px;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    max-width: 200px;
    max-height: 70px;

    img {
      max-width: 200px;
      max-height: 70px;
    }
  }
`

export const Name = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(34)};
  opacity: 0.7;

  ${({ theme }) => theme.breakpoints.down("md")} {
    line-height: ${({ theme }) => theme.typography.pxToRem(26)};
  }
`

export const Testimonial = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  margin-bottom: 1rem;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    line-height: ${({ theme }) => theme.typography.pxToRem(26)};
  }
`
